import { Plugin } from 'vue';
import { install } from './plugin';
export { useFileUploadBox } from './fileUploadBox';

export default {
  install,
} as Plugin;
